import React from "react";
import { connect } from "react-redux";
import Navigation from "../Components/Navigation";
import NavigationDesktop from "../Components/NavigationDesktop";
import useWindowSize from "../Components/Hooks/useWindowSize";
import { BREAKPOINT_FOR_MOBILE_MENU } from "../constants";

const NavigationContainer = (props) => {
  const [windowWidth] = useWindowSize();
  return (
    <>
      {windowWidth < BREAKPOINT_FOR_MOBILE_MENU ? (
        <Navigation {...props} />
      ) : (
        <NavigationDesktop {...props} />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    links: state.navigation.contentLinks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationContainer);
